module.exports = __webpack_public_path__ + "img/maison6.21a96849.jpg";